<HomeNavBar />

<div class="container-fluid pb-extra">
  <div class="mb-4">
    <div class="d-flex flex-column flex-lg-row align-items-lg-end justify-content-between gap-3 mb-1">
      <div>
        <div class="d-flex align-items-center gap-2 mb-1">
          <button
            class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
            @click="$router.push({ name: 'my_shop' })"
          >
            <i class="bi bi-chevron-left fs-5"></i>
          </button>
          <h4 class="fw-bold text-dark mb-0 fs-4">Orders</h4>
        </div>
        <p class="text-muted mb-0">
          Track all incoming orders, review sales totals, and manage customers on credit from one page.
        </p>
      </div>

    </div>

    <div class="card border-0 shadow-sm rounded-4 p-1 bg-white">
        <ul
          class="nav nav-tabs flex-nowrap text-xxs portal-icon-tabs portal-icon-tabs--light"
          id="portal-tabs"
          role="tablist"
        >
    <!-- Orders -->
    <button
      class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
      :class="{ active: active_orders_tab === 'orders' }"
      @click="active_orders_tab = 'orders'"
      type="button"
    >
      <i class="bi bi-receipt"></i>
      <span style="white-space: nowrap;">Orders</span>
    </button>

    <!-- Credit -->
    <button
      class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
      :class="{ active: active_orders_tab === 'credit' }"
      @click="active_orders_tab = 'credit'"
      type="button"
    >
      <i class="bi bi-people"></i>
      <span >Users on Credit</span>
    </button>

    <!-- Wallet -->
    <button
      class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
      :class="{ active: active_orders_tab === 'wallet' }"
      @click="active_orders_tab = 'wallet'"
      type="button"
    >
      <i class="bi bi-wallet2"></i>
      <span>Wallet</span>
    </button>
        </ul>
    </div>

    <div v-if="active_orders_tab === 'orders'" class="card border-0 shadow-sm rounded p-3 mt-3 mb-3 bg-white">
      <div class="row g-2">
        <div class="col-12 col-md-6 col-xl-3">
          <div class="text-muted small fw-semibold mb-1">Search</div>
          <div class="input-group rounded">
            <span class="input-group-text bg-white border-end-0 rounded-start-4">
              <i class="bi bi-search text-muted"></i>
            </span>
            <input
              v-model="search_query"
              type="text"
              class="form-control border-start-0 rounded-end-4 shadow-none"
              placeholder="Search buyer or order number"
            />
          </div>
        </div>

        <div class="col-12 d-md-none">
          <button
            type="button"
            class="btn btn-light border rounded w-100 d-inline-flex align-items-center justify-content-between"
            @click="show_mobile_order_filters = !show_mobile_order_filters"
          >
            <span class="fw-semibold text-dark">Other Filters</span>
            <i class="bi" :class="show_mobile_order_filters ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>
        </div>

        <div
          class="col-12 col-md-6 col-xl-3"
          :class="{ 'd-none d-md-block': !show_mobile_order_filters }"
        >
          <div class="text-muted small fw-semibold mb-1">Order Status</div>
          <select v-model="order_filter" class="form-select shadow-none">
            <option value="all">All Orders</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="paid">Paid</option>
            <option value="rejected">Not Approved</option>
          </select>
        </div>
        <div
          class="col-12 col-md-6 col-xl-2"
          :class="{ 'd-none d-md-block': !show_mobile_order_filters }"
        >
          <div class="text-muted small fw-semibold mb-1">Month</div>
          <select v-model="sales_selected_month" class="form-select shadow-none">
            <option value="all">All Months</option>
            <option v-for="option in month_options" :key="`sales-${option.value}`" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
        <div
          class="col-12 col-md-6 col-xl-2"
          :class="{ 'd-none d-md-block': !show_mobile_order_filters }"
        >
          <div class="text-muted small fw-semibold mb-1">Payment Type</div>
          <select v-model="sales_payment_filter" class="form-select shadow-none">
            <option value="all">All Payments</option>
            <option value="credit">Credit</option>
            <option value="paid">Pay Now</option>
          </select>
        </div>
        <div
          class="col-12 col-md-6 col-xl-2"
          :class="{ 'd-none d-md-block': !show_mobile_order_filters }"
        >
          <div class="text-muted small fw-semibold mb-1">Fulfilment</div>
          <select v-model="sales_delivery_filter" class="form-select shadow-none">
            <option value="all">All Fulfilment Types</option>
            <option value="collection">Collection</option>
            <option value="delivery">Delivery</option>
          </select>
        </div>
      </div>
    </div>

    <div v-if="active_orders_tab === 'orders'" class="position-relative mb-3">
      <button
        type="button"
        class="btn btn-sm btn-light border rounded-circle d-flex d-md-none align-items-center justify-content-center orders-scroll-arrow orders-scroll-arrow-left"
        @click="scroll_stats('left')"
        aria-label="Scroll left"
      >
        <i class="bi bi-chevron-left"></i>
      </button>

      <div ref="statsScroller" class="row g-1 orders-stats-scroll">
        <div class="col-12 col-sm-6 col-xl-3 orders-stat-col">
          <button
            class="card border-0 shadow-sm rounded p-2 p-md-3 w-100 text-start bg-white h-100"
            :class="{ 'orders-stat-card-active': order_filter === 'all' }"
            @click="set_filter('all')"
            type="button"
          >
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="text-muted small lh-sm">Total Orders</div>
              <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center p-2 orders-stat-icon">
                <i class="bi bi-bag"></i>
              </div>
            </div>
            <div class="fs-4 fw-bold text-dark lh-1">{{ order_stats.total }}</div>
            <div class="text-muted small mt-1">R{{ format_price(order_amount_stats.total) }}</div>
          </button>
        </div>

        <div class="col-12 col-sm-6 col-xl-3 orders-stat-col">
          <button
            class="card border-0 shadow-sm rounded p-2 p-md-3 w-100 text-start bg-white h-100"
            :class="{ 'orders-stat-card-active': order_filter === 'pending' }"
            @click="set_filter('pending')"
            type="button"
          >
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="text-muted small lh-sm">Pending</div>
              <div class="rounded-circle bg-warning-subtle text-warning-emphasis d-inline-flex align-items-center justify-content-center p-2 orders-stat-icon">
                <i class="bi bi-hourglass-split"></i>
              </div>
            </div>
            <div class="fs-4 fw-bold text-dark lh-1">{{ order_stats.pending }}</div>
            <div class="text-muted small mt-1">R{{ format_price(order_amount_stats.pending) }}</div>
          </button>
        </div>

        <div class="col-12 col-sm-6 col-xl-3 orders-stat-col">
          <button
            class="card border-0 shadow-sm rounded p-2 p-md-3 w-100 text-start bg-white h-100"
            :class="{ 'orders-stat-card-active': order_filter === 'approved' }"
            @click="set_filter('approved')"
            type="button"
          >
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="text-muted small lh-sm">Approved</div>
              <div class="rounded-circle bg-success-subtle text-success d-inline-flex align-items-center justify-content-center p-2 orders-stat-icon">
                <i class="bi bi-bag-check"></i>
              </div>
            </div>
            <div class="fs-4 fw-bold text-dark lh-1">{{ order_stats.approved }}</div>
            <div class="text-muted small mt-1">R{{ format_price(order_amount_stats.approved) }}</div>
          </button>
        </div>

        <div class="col-12 col-sm-6 col-xl-3 orders-stat-col">
          <button
            class="card border-0 shadow-sm rounded p-2 p-md-3 w-100 text-start bg-white h-100"
            :class="{ 'orders-stat-card-active': order_filter === 'paid' }"
            @click="set_filter('paid')"
            type="button"
          >
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="text-muted small lh-sm">Paid</div>
              <div class="rounded-circle bg-success-subtle text-success d-inline-flex align-items-center justify-content-center p-2 orders-stat-icon">
                <i class="bi bi-credit-card"></i>
              </div>
            </div>
            <div class="fs-4 fw-bold text-dark lh-1">{{ order_stats.paid }}</div>
            <div class="text-muted small mt-1">R{{ format_price(order_amount_stats.paid) }}</div>
          </button>
        </div>

        <div class="col-12 col-sm-6 col-xl-3 orders-stat-col">
          <button
            class="card border-0 shadow-sm rounded p-2 p-md-3 w-100 text-start bg-white h-100"
            :class="{ 'orders-stat-card-active': order_filter === 'credit' }"
            @click="set_filter('credit')"
            type="button"
          >
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="text-muted small lh-sm">Credit</div>
              <div class="rounded-circle bg-secondary-subtle text-secondary d-inline-flex align-items-center justify-content-center p-2 orders-stat-icon">
                <i class="bi bi-credit-card-2-front"></i>
              </div>
            </div>
            <div class="fs-4 fw-bold text-dark lh-1">{{ order_stats.credit }}</div>
            <div class="text-muted small mt-1">R{{ format_price(order_amount_stats.credit) }}</div>
          </button>
        </div>

        <div class="col-12 col-sm-6 col-xl-3 orders-stat-col">
          <button
            class="card border-0 shadow-sm rounded p-2 p-md-3 w-100 text-start bg-white h-100"
            :class="{ 'orders-stat-card-active': order_filter === 'rejected' }"
            @click="set_filter('rejected')"
            type="button"
          >
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="text-muted small lh-sm">Not Approved</div>
              <div class="rounded-circle bg-danger-subtle text-danger d-inline-flex align-items-center justify-content-center p-2 orders-stat-icon">
                <i class="bi bi-x-circle"></i>
              </div>
            </div>
            <div class="fs-4 fw-bold text-dark lh-1">{{ order_stats.rejected }}</div>
            <div class="text-muted small mt-1">R{{ format_price(order_amount_stats.rejected) }}</div>
          </button>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-sm btn-light border rounded-circle d-flex d-md-none align-items-center justify-content-center orders-scroll-arrow orders-scroll-arrow-right"
        @click="scroll_stats('right')"
        aria-label="Scroll right"
      >
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>

    <div v-if="active_orders_tab === 'credit' && !selected_customer" class="card border-0 shadow-sm rounded p-3 mt-3 bg-white">
      <div class="row g-2">
        <div class="col-12 col-md-6 col-xl-5">
          <div class="text-muted small fw-semibold mb-1">Search</div>
          <div class="input-group rounded">
            <span class="input-group-text bg-white border-end-0 rounded-start-4">
              <i class="bi bi-search text-muted"></i>
            </span>
            <input
              v-model="customer_query"
              type="text"
              class="form-control border-start-0 rounded-end-4 shadow-none"
              placeholder="Search customer or order number"
            />
          </div>
        </div>

        <div class="col-12 d-md-none">
          <button
            type="button"
            class="btn btn-light border rounded w-100 d-inline-flex align-items-center justify-content-between"
            @click="show_mobile_credit_filters = !show_mobile_credit_filters"
          >
            <span class="fw-semibold text-dark">Other Filters</span>
            <i class="bi" :class="show_mobile_credit_filters ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>
        </div>

        <div
          class="col-12 col-md-6 col-xl-3"
          :class="{ 'd-none d-md-block': !show_mobile_credit_filters }"
        >
          <div class="text-muted small fw-semibold mb-1">Month</div>
          <select v-model="credit_selected_month" class="form-select shadow-none">
            <option value="all">All Months</option>
            <option v-for="option in month_options" :key="`credit-${option.value}`" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
        <div
          class="col-12 col-md-6 col-xl-4"
          :class="{ 'd-none d-md-block': !show_mobile_credit_filters }"
        >
          <div class="text-muted small fw-semibold mb-1">Credit Status</div>
          <select v-model="credit_status_filter" class="form-select shadow-none">
            <option value="all">All Credit Statuses</option>
            <option value="outstanding">Not Settled</option>
            <option value="settled">Settled</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="loading"
    class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
    role="status"
    aria-live="polite"
  >
    <div class="marketplace-loader-card">
      <div class="marketplace-loader-orbit">
        <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
        <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
        <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
          <i class="bi bi-bag-heart-fill"></i>
        </span>
        <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
        <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
      </div>
      <p class="marketplace-loader-title mb-1">Loading orders</p>
      <p class="marketplace-loader-copy mb-0">
        We are bringing your orders into view.
      </p>
    </div>
  </div>

  <div v-else-if="active_orders_tab === 'orders'">
    <div v-if="filtered_orders && filtered_orders.length > 0">
      <div
        v-for="order in filtered_orders"
        :key="order.id"
        class="card mb-3 shadow rounded overflow-hidden border-0 bg-light"
        :class="String(order?.order_status_name || '').trim().toLowerCase() === 'pending' ? 'border-start border-5 border-success' : ''"
      >
        <div class="d-flex align-items-center gap-3 p-3 flex-wrap" @click="toggle_expand(order)">
          <div class="flex-fill">
          <p class="mb-0 fw-bold">{{ order.buyer_name }} · {{ order.order_number }}
            <span
              v-if="String(order?.order_status_name || '').trim().toLowerCase() === 'pending'"
              class="badge rounded-pill bg-success text-white border border-success-subtle"
            >
              Pending Order
            </span>
            <span
              v-else-if="String(order?.order_status_name || '').trim().toLowerCase() === 'paid'"
              class="badge rounded-pill bg-success-subtle text-success border border-success-subtle"
            >
              Paid
            </span>
            <span
              v-else-if="['rejected'].includes(String(order?.order_status_name || '').trim().toLowerCase())"
              class="badge rounded-pill bg-danger-subtle text-danger border border-danger-subtle"
            >
              Not Approved
            </span>
            <span
              v-else-if="['cancelled'].includes(String(order?.order_status_name || '').trim().toLowerCase())"
              class="badge rounded-pill bg-danger-subtle text-danger border border-danger-subtle"
            >
              Cancelled
            </span>
            <span
              v-else-if="['approved', 'accepted'].includes(String(order?.order_status_name || '').trim().toLowerCase())"
              class="badge rounded-pill bg-primary-subtle text-primary border border-primary-subtle"
            >
              Approved
            </span>
            <span
              v-else-if="String(order?.order_status_name || '').trim().toLowerCase() === 'credit'"
              class="badge rounded-pill bg-secondary-subtle text-secondary border border-secondary-subtle"
            >
              Credit
            </span>
          </p>
            <small>
              {{ order.items.length }} items · R{{ format_price(order.total_amount) }}
            </small>
            <small v-if="order.promo_used" class="d-flex text-success fw-semibold">
              <i class="bi bi-tag-fill me-1"></i>
              Promo used
            </small>
            <small class="d-flex">Order Placed: {{ format_date_time(order.created_at) }}</small>
          </div>
          <div
            v-if="order.pargo_delivery === null"
            class="d-inline-flex align-items-center gap-1 rounded border px-2 py-1 text-muted small"
          >
            <i class="bi bi-bag-check"></i>
            <span>Collection</span>
          </div>
          <div
            v-else
            class="d-inline-flex align-items-center gap-1 rounded border px-2 py-1 text-muted small"
          >
            <i class="bi bi-truck"></i>
            <span>Delivery</span>
          </div>
          <div class="w-100 d-flex justify-content-end text-muted small fw-bold">
            <i
              class="bi"
              :class="order.is_expanded ? 'bi-chevron-up' : 'bi-chevron-down'"
            ></i>
          </div>
        </div>

        <div v-if="order.is_expanded" class="border-top pt-3">
          <div
            v-for="item in order.items"
            :key="item.id"
            class="d-flex align-items-center gap-2 mx-3 mb-2 p-2 bg-light rounded"
          >
            <img
              v-if="item.product_images && item.product_images.length"
              :src="item.product_images[0].image_url"
              class="cart-item-image me-2 rounded border border-1"
            />

            <div class="d-flex flex-column justify-content-center">
              <div class="d-flex flex-column mb-0">
                <span class="fw-semibold">{{ item.product_name }}</span>
                <small
                  v-for="(attribute, index) in get_item_attributes(item)"
                  :key="`${item.id}-attribute-${index}`"
                  class="text-muted"
                >
                  {{ attribute.label }}: {{ attribute.value }}
                </small>
                <span class="text-black small">
                  Quantity {{ item.quantity }} X R{{ item.total_price }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-3 pt-2 border-top">
            <div v-if="order.promo_used" class="card border shadow-sm rounded bg-white mb-3">
              <div class="card-body py-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span class="text-muted">Subtotal</span>
                  <strong>R{{ format_price(order.subtotal_amount) }}</strong>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-2 text-success">
                  <span class="fw-semibold">
                    <i class="bi bi-tag-fill me-1"></i>
                    Promo Discount
                  </span>
                  <strong>
                    -R{{ format_price(order.discount_amount) }}
                  </strong>
                </div>
                <div v-if="order.promo_code" class="d-flex justify-content-between align-items-center mb-2 text-muted">
                  <span>Promo</span>
                  <strong>
                    {{ order.promo_code.promo_code_type?.name === 'percentage'
                      ? order.promo_code.discount_amount + '%'
                      : 'R' + format_price(order.promo_code.discount_amount) }}
                  </strong>
                </div>
                <div class="d-flex justify-content-between align-items-center pt-2 border-top">
                  <span>Total</span>
                  <strong>R{{ format_price(order.total_amount) }}</strong>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-end gap-3">
              <div class="d-flex flex-column text-start">
                <small class="text-muted">
                  Payment Type:
                  {{
                    String(order?.payment_type).trim().toLowerCase().includes('credit')
                      ? 'Credit'
                      : 'Paying Now'
                  }}
                </small>
                <small v-if="order.promo_used" class="text-success fw-semibold">
                  Paid total includes promo discount
                </small>
              </div>
              <div
                v-if="order.order_status_name === 'pending'"
                class="d-flex gap-2 justify-content-end orders-action-group w-100"
              >
                <button
                  class="btn btn-primary rounded btn-sm orders-action-control flex-fill flex-md-grow-0"
                  :disabled="is_updating_order(order.id)"
                  @click="request_order_status_update(order.id, 'approved')"
                >
                  <span v-if="is_updating_order_action(order.id, 'approved')" class="d-inline-flex align-items-center justify-content-center gap-2">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Updating...
                  </span>
                  <span v-else>Accept</span>
                </button>

                <button
                  class="btn btn-danger rounded btn-sm orders-action-control flex-fill flex-md-grow-0"
                  :disabled="is_updating_order(order.id)"
                  @click="reject_order(order)"
                >
                  <span v-if="is_updating_order_action(order.id, 'rejected')" class="d-inline-flex align-items-center justify-content-center gap-2">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Updating...
                  </span>
                  <span v-else>Reject</span>
                </button>
              </div>
              <div v-else-if="order.order_status_name === 'approved'" class="d-flex justify-content-end w-100">
                <span
                  v-if="is_credit_order(order)"
                  class="badge rounded bg-secondary-subtle text-secondary border border-secondary-subtle px-3 py-2 orders-action-control"
                >
                  Credit
                </span>
                <button
                  v-else
                  class="btn btn-primary rounded btn-sm orders-action-control"
                  :disabled="is_updating_order(order.id)"
                  @click="request_order_status_update(order.id, 'paid')"
                >
                  <span v-if="is_updating_order_action(order.id, 'paid')" class="d-inline-flex align-items-center justify-content-center gap-2">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Updating...
                  </span>
                  <span v-else>Confirm Paid on {{ order.pargo_delivery === null ? 'Collection' : 'Delivery' }}</span>
                </button>
              </div>
              <div v-else-if="order.order_status_name === 'credit'" class="d-flex justify-content-end w-100">
                <span class="badge rounded bg-secondary-subtle text-secondary border border-secondary-subtle px-3 py-2 orders-action-control">
                  Credit
                </span>
              </div>
              <div v-else-if="order.order_status_name === 'rejected'" class="d-flex justify-content-end w-100">
                <span class="badge rounded bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 orders-action-control">
                  Not Approved
                </span>
              </div>
              <div v-else-if="String(order?.order_status_name || '').trim().toLowerCase() === 'paid'" class="d-flex justify-content-end w-100">
                <span class="badge rounded bg-success-subtle text-success border border-success-subtle px-3 py-2 orders-action-control">
                  Paid
                </span>
              </div>
              <div v-else-if="order.order_status_name === 'cancelled'" class="d-flex justify-content-end w-100">
                <span class="badge rounded bg-secondary-subtle text-secondary border border-secondary-subtle px-3 py-2 orders-action-control">
                  Cancelled
                </span>
              </div>
              <div v-else-if="order.order_status_name === 'completed'" class="d-flex justify-content-end w-100">
                <button
                  class="btn btn-primary rounded btn-sm orders-action-control"
                  :disabled="is_updating_order(order.id)"
                  @click="request_order_status_update(order.id, 'completed')"
                >
                  <span v-if="is_updating_order_action(order.id, 'completed')" class="d-inline-flex align-items-center justify-content-center gap-2">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Updating...
                  </span>
                  <span v-else>Mark Completed</span>
                </button>
              </div>

              <div v-else class="d-flex justify-content-end w-100">
                <span class="badge rounded bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-2 orders-action-control">
                  Processing
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="text-center py-3">
      <i class="bi bi-inbox text-muted display-6"></i>
      <p class="text-muted text-xs mt-2 mb-0">No orders found</p>
    </div>
  </div>

  <div v-else-if="active_orders_tab === 'wallet'" class="mb-4">
    <section class="row g-3 mb-3">
      <div class="col-12 col-lg-4">
        <div class="card border-0 shadow-sm rounded p-3 p-lg-4 h-100 bg-white">
          <div
            class="d-flex align-items-start justify-content-between gap-2 mb-3"
          >
            <div class="text-muted text-xxs">Available Balance</div>
            <div class="text-primary">
              <i class="bi bi-wallet2"></i>
            </div>
          </div>
          <div class="fs-5 fw-bold text-dark mb-1">
            R {{ format_price(wallet?.available_amount) }}
          </div>
          <div class="text-muted text-xxs">Ready to withdraw</div>
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="card border-0 shadow-sm rounded p-3 p-lg-4 h-100 bg-white">
          <div
            class="d-flex align-items-start justify-content-between gap-2 mb-3"
          >
            <div class="text-muted text-xxs">Pending Balance</div>
            <div class="text-muted">
              <i class="bi bi-clock"></i>
            </div>
          </div>
          <div class="fs-5 fw-bold text-dark mb-1">
            R {{ format_price(wallet?.pending_amount) }}
          </div>
          <div class="text-muted text-xxs">Releases in up to 7 days</div>
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="card border-0 shadow-sm rounded p-3 p-lg-4 h-100 bg-white">
          <div class="d-flex align-items-start gap-2">
            <div class="text-primary mt-1">
              <i class="bi bi-info-circle"></i>
            </div>
            <p class="text-muted text-xxs mb-0">
              Funds from new orders are held as
              <span class="fw-semibold text-dark">Pending</span> for 7 days,
              then automatically move to
              <span class="fw-semibold text-dark">Available</span>. Pending
              funds cannot be withdrawn before the hold period ends.
            </p>
          </div>
        </div>
      </div>
    </section>
    <button
      class="btn rounded px-3 flex-fill flex-lg-grow-0 text-nowrap btn-primary mb-2 d-none"
      type="button"
      @click="open_withdraw_modal"
      data-bs-toggle="modal"
      data-bs-target="#withdrawModal"
    >
      Withdraw
    </button>
    <section class="card border-0 shadow-sm rounded p-3 p-lg-4 bg-white">
      <h6 class="fw-bold text-dark mb-3">Pending Releases</h6>

      <div
        v-for="(order, index) in pending_release_orders"
        :key="`pending-release-${order?.id}`"
        class="d-flex align-items-start justify-content-between gap-3 py-3"
        :class="{ 'border-bottom': index !== pending_release_orders.length - 1 }"
      >
        <div class="flex-fill">
          <div class="fw-semibold text-dark">{{ order.buyer_name }} · {{ order.order_number }}</div>
          <div class="text-muted small">{{ format_pending_release_label(order) }}</div>
        </div>
        <div class="text-end">
          <div class="fw-bold text-dark">R{{ format_price(order?.total_amount) }}</div>
          <div class="text-muted small">Pending</div>
        </div>
      </div>

      <div v-if="!pending_release_orders.length" class="text-muted small">
        No pending releases in the last 7 days.
      </div>
    </section>

    <teleport to="body">
      <div
        id="withdrawModal"
        class="modal fade"
        :class="{ show: show_withdraw_modal }"
        :style="{ display: show_withdraw_modal ? 'block' : 'none' }"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        :aria-hidden="show_withdraw_modal ? 'false' : 'true'"
        aria-labelledby="withdrawModalLabel"
        @click.self="close_withdraw_modal"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content border-0 rounded-4 shadow">
            <div class="modal-header border-0 pb-0">
              <div>
                <h5 id="withdrawModalLabel" class="modal-title fw-bold text-dark">Withdraw funds</h5>
                <div class="text-muted">
                  Available balance: <span class="fw-semibold text-dark">R{{ format_price(wallet?.available_amount) }}</span>
                </div>
              </div>
              <button type="button" class="btn-close" aria-label="Close" @click="close_withdraw_modal"></button>
            </div>

            <div class="modal-body pt-3">
              <div v-if="withdraw_error_message" class="alert alert-danger py-2" role="alert">
                {{ withdraw_error_message }}
              </div>

              <div class="mb-3">
                <div class="small fw-semibold text-dark mb-1">Amount (min R50)</div>
                <input
                  v-model.number="withdraw_amount"
                  type="number"
                  class="form-control form-control-lg"
                  min="50"
                  step="1"
                  placeholder="0.00"
                />
              </div>
              <div class="mb-3">
                <div class="small fw-semibold text-dark mb-1">Account number</div>
                <input
                  v-model="withdraw_account_number"
                  type="text"
                  class="form-control"
                  placeholder="FNB · 1234567890"
                />
              </div>
            </div>

            <div class="modal-footer border-0 pt-0">
              <button type="button" class="btn btn-light" @click="close_withdraw_modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="review_withdrawal">Review</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="show_withdraw_modal" class="modal-backdrop fade show"></div>
    </teleport>
  </div>

  <div v-else>
    <section v-if="!selected_customer" class="row g-2 g-lg-3 mb-4">
      <div class="col-6 col-xl-3">
        <div class="card border-0 shadow-sm rounded p-3 h-100 bg-white">
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center p-2">
              <i class="bi bi-people"></i>
            </div>
            <div class="text-muted small fw-semibold text-uppercase">Users on Credit</div>
          </div>
          <div class="fs-5 fw-bold text-dark mb-1">{{ credit_stats.customers_on_credit }}</div>
          <div class="text-muted small">Customers with credit orders</div>
        </div>
      </div>

      <div class="col-6 col-xl-3">
        <div class="card border-0 shadow-sm rounded p-3 h-100 bg-white">
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="rounded-circle bg-danger-subtle text-danger d-inline-flex align-items-center justify-content-center p-2">
              <i class="bi bi-exclamation-circle"></i>
            </div>
            <div class="text-muted small fw-semibold text-uppercase">Not Settled</div>
          </div>
          <div class="fs-5 fw-bold text-dark mb-1">R{{ format_price(credit_stats.outstanding_amount) }}</div>
          <div class="text-muted small">{{ credit_stats.outstanding_count }} open credit orders</div>
        </div>
      </div>

      <div class="col-6 col-xl-3">
        <div class="card border-0 shadow-sm rounded p-3 h-100 bg-white">
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="rounded-circle bg-success-subtle text-success d-inline-flex align-items-center justify-content-center p-2">
              <i class="bi bi-check2-circle"></i>
            </div>
            <div class="text-muted small fw-semibold text-uppercase">Settled</div>
          </div>
          <div class="fs-5 fw-bold text-dark mb-1">R{{ format_price(credit_stats.paid_amount) }}</div>
          <div class="text-muted small">{{ credit_stats.paid_count }} settled credit orders</div>
        </div>
      </div>

      <div class="col-6 col-xl-3">
        <div class="card border-0 shadow-sm rounded p-3 h-100 bg-white">
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="rounded-circle bg-warning-subtle text-warning-emphasis d-inline-flex align-items-center justify-content-center p-2">
              <i class="bi bi-receipt"></i>
            </div>
            <div class="text-muted small fw-semibold text-uppercase">Credit Orders</div>
          </div>
          <div class="fs-5 fw-bold text-dark mb-1">{{ credit_stats.total_credit_orders }}</div>
          <div class="text-muted small">Total orders on credit</div>
        </div>
      </div>
    </section>

    <section v-if="selected_customer" class="card border-0 shadow-sm rounded p-3 p-lg-4 mb-4 bg-light">
      <div class="d-flex flex-column flex-md-row align-items-md-center gap-2 mb-4">
        <button
          class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn align-self-start"
          @click="clear_selected_customer"
        >
          <i class="bi bi-chevron-left fs-5"></i>
        </button>
        <div>
          <h5 class="fw-bold text-dark mb-0">{{ selected_customer.buyer_name }}</h5>
          <div class="text-muted small">Credit order activity and settlement</div>
        </div>
      </div>

      <div class="row g-2 g-lg-3 mb-4">
        <div class="col-6">
          <div class="card border-0 shadow-sm rounded bg-white h-100">
            <div class="card-body p-3">
              <div class="text-muted small fw-semibold text-uppercase mb-2">Not Settled Balance</div>
              <div class="fs-5 fw-bold text-danger">R{{ format_price(selected_customer.outstanding_amount) }}</div>
              <div class="text-muted small mt-1">{{ selected_customer_unpaid_orders.length }} open credit orders</div>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="card border-0 shadow-sm rounded bg-white h-100">
            <div class="card-body p-3">
              <div class="text-muted small fw-semibold text-uppercase mb-2">Settled Balance</div>
              <div class="fs-5 fw-bold text-success">R{{ format_price(selected_customer.paid_amount) }}</div>
              <div class="text-muted small mt-1">{{ selected_customer_paid_orders.length }} settled credit orders</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0 shadow-sm rounded bg-white mb-4">
        <div class="table-responsive px-3 px-lg-4 py-3 d-none d-lg-block">
          <table class="table align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th class="small text-uppercase text-muted fw-semibold py-3">Order ID</th>
                <th class="small text-uppercase text-muted fw-semibold py-3">Date</th>
                <th class="small text-uppercase text-muted fw-semibold py-3">Product</th>
                <th class="small text-uppercase text-muted fw-semibold py-3">Amount</th>
                <th class="small text-uppercase text-muted fw-semibold py-3">Status</th>
                <th class="small text-uppercase text-muted fw-semibold py-3 text-end">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in selected_customer_orders" :key="order.id">
                <td class="py-3 fw-bold text-dark">{{ order?.order_number || order?.id }}</td>
                <td class="py-3 text-muted small">{{ format_short_date(order?.created_at) }}</td>
                <td class="py-3 fw-semibold text-dark">{{ get_order_products_label(order) }}</td>
                <td class="py-3 fw-bold text-dark">R{{ format_price(order?.total_amount) }}</td>
                <td class="py-3">
                  <span
                    class="fw-semibold"
                    :class="is_order_paid(order) ? 'text-success' : 'text-danger'"
                  >
                    {{ is_order_paid(order) ? "Settled" : "Not Settled" }}
                  </span>
                </td>
                <td class="text-end py-3">
                  <button
                    v-if="!is_order_paid(order)"
                    class="btn btn-sm btn-primary rounded px-3"
                    :disabled="is_settling_order(order.id)"
                    @click="settle_order(order)"
                  >
                    <span v-if="is_settling_order(order.id)" class="d-inline-flex align-items-center gap-2">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span>Settling...</span>
                    </span>
                    <span v-else>Settle Credit</span>
                  </button>
                  <button v-else class="btn btn-sm btn-light border rounded px-3" disabled>
                    Settled
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-lg-none p-2">
          <div class="d-flex flex-column gap-3">
            <div
              v-for="order in selected_customer_orders"
              :key="`mobile-${order.id}`"
              class="border rounded bg-light p-3"
            >
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div>
                  <div class="fw-bold text-dark">{{ order?.order_number || order?.id }}</div>
                  <div class="text-muted small">{{ format_short_date(order?.created_at) }}</div>
                </div>
                <div
                  class="fw-semibold small text-end"
                  :class="is_order_paid(order) ? 'text-success' : 'text-danger'"
                >
                  {{ is_order_paid(order) ? "Settled" : "Not Settled" }}
                </div>
              </div>

              <div class="d-flex align-items-center justify-content-between gap-3 py-2 border-top">
                <div class="text-muted text-uppercase small fw-semibold">Product</div>
                <div class="fw-semibold text-dark text-end">{{ get_order_products_label(order) }}</div>
              </div>

              <div class="d-flex align-items-center justify-content-between gap-3 py-2 border-top">
                <div class="text-muted text-uppercase small fw-semibold">Amount</div>
                <div class="fw-bold text-dark text-end">R{{ format_price(order?.total_amount) }}</div>
              </div>

              <div class="pt-3 border-top mt-2">
                <div v-if="!is_order_paid(order)" class="d-grid">
                  <button
                    class="btn btn-sm btn-primary rounded py-1"
                    :disabled="is_settling_order(order.id)"
                    @click="settle_order(order)"
                  >
                    <span v-if="is_settling_order(order.id)" class="d-inline-flex align-items-center justify-content-center gap-2">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span>Settling...</span>
                    </span>
                    <span v-else>Settle Order</span>
                  </button>
                </div>
                <div v-else class="d-flex justify-content-end">
                  <button class="btn btn-sm btn-light border rounded px-3" disabled>
                    Settled
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="selected_customer_unpaid_orders.length" class="d-grid d-sm-flex justify-content-sm-end">
        <button
          class="btn btn-primary rounded px-3 px-sm-4 py-2 fw-bold text-wrap"
          :disabled="is_settling_all_customer_orders"
          @click="settle_all_customer_orders"
        >
          <span v-if="is_settling_all_customer_orders" class="d-inline-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span>Settling orders...</span>
          </span>
          <span v-else>
            Settle R{{ format_price(selected_customer_unpaid_total) }} for {{ selected_customer_unpaid_orders.length }} orders
          </span>
        </button>
      </div>
    </section>

    <section v-else-if="customer_accounts.length" class="card border-0 shadow-sm rounded overflow-hidden mb-4 bg-light">
      <div class="p-3 p-lg-4 border-bottom">
        <h6 class="fw-bold text-dark mb-1">Users on Credit</h6>
        <div class="text-muted small">
          Showing {{ customer_page_start }}-{{ customer_page_end }} of {{ customer_accounts.length }} customers
        </div>
      </div>

      <div class="d-lg-none p-2">
        <div class="d-flex flex-column gap-3">
          <div
            v-for="customer in paginated_customer_accounts"
            :key="`mobile-card-${customer.id}`"
            class="card border shadow-sm rounded bg-white"
          >
            <div class="card-body p-3">
              <button
                type="button"
                class="btn w-100 text-start p-0 border-0 bg-transparent shadow-none"
                @click="toggle_customer_account(customer)"
              >
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <div class="d-flex align-items-center gap-3 min-w-0">
                    <div class="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0" style="width: 46px; height: 46px;">
                      {{ get_customer_initials(customer.buyer_name) }}
                    </div>
                    <div class="min-w-0">
                      <div class="fw-bold text-dark mb-0">{{ customer.buyer_name }}</div>
                    </div>
                  </div>

                  <div class="d-flex flex-column align-items-end gap-2 flex-shrink-0">
                    <span
                      class="badge rounded-pill px-2 py-2 fw-semibold text-wrap"
                      :class="customer_has_unpaid_orders(customer) ? 'bg-danger-subtle text-danger' : 'bg-success-subtle text-success'"
                    >
                      {{ customer_has_unpaid_orders(customer) ? `${customer.unpaid_count} Not Settled` : `${customer.paid_count} Settled` }}
                    </span>
                    <i
                      class="bi text-muted"
                      :class="is_customer_account_expanded(customer) ? 'bi-chevron-up' : 'bi-chevron-down'"
                    ></i>
                  </div>
                </div>
              </button>

              <div v-if="is_customer_account_expanded(customer)" class="border-top pt-3 mt-3">
                <div class="d-flex flex-column gap-3 mb-3">
                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <div class="text-muted text-uppercase small fw-semibold">Outstanding</div>
                    <div class="fw-bold text-danger fs-6 text-end">R{{ format_price(customer.outstanding_amount) }}</div>
                  </div>

                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <div class="text-muted text-uppercase small fw-semibold">Settled</div>
                    <div class="fw-bold text-success fs-6 text-end">R{{ format_price(customer.paid_amount) }}</div>
                  </div>

                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <div class="text-muted text-uppercase small fw-semibold">Orders</div>
                    <div class="fw-semibold small text-dark text-end">{{ customer.order_count }}</div>
                  </div>
                </div>

                <div class="border-top pt-3 d-flex justify-content-start">
                  <button
                    type="button"
                    class="btn btn-link text-decoration-none text-primary fw-semibold px-0"
                    @click="select_customer(customer)"
                  >
                    View Account
                    <i class="bi bi-arrow-right-short ms-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-group list-group-flush d-none d-lg-block">
        <button
          v-for="customer in paginated_customer_accounts"
          :key="customer.id"
          type="button"
          class="list-group-item list-group-item-action px-3 px-lg-4 py-3 border-0 border-top text-start"
          @click="select_customer(customer)"
        >
          <div class="row g-3 align-items-center">
            <div class="col-12 col-lg-4">
              <div class="d-flex align-items-center gap-3">
                <div class="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center fw-bold p-3 flex-shrink-0">
                  {{ get_customer_initials(customer.buyer_name) }}
                </div>
                <div class="min-w-0">
                  <div class="fw-bold text-dark">{{ customer.buyer_name }}</div>
                  <div class="text-muted small">{{ customer.order_count }} orders</div>
                </div>
              </div>
            </div>

            <div class="col-6 col-lg-2">
              <div class="text-muted text-uppercase small fw-semibold mb-1">Outstanding</div>
              <div class="fw-bold text-danger">R{{ format_price(customer.outstanding_amount) }}</div>
            </div>

            <div class="col-6 col-lg-2">
              <div class="text-muted text-uppercase small fw-semibold mb-1">Settled</div>
              <div class="fw-bold text-success">R{{ format_price(customer.paid_amount) }}</div>
            </div>

            <div class="col-12 col-lg-2">
              <div class="text-muted text-uppercase small fw-semibold mb-1">Status</div>
              <span
                class="fw-semibold"
                :class="customer_has_unpaid_orders(customer) ? 'text-danger' : 'text-success'"
              >
                {{ customer_has_unpaid_orders(customer) ? `${customer.unpaid_count} Not Settled` : `${customer.paid_count} Settled` }}
              </span>
            </div>

            <div class="col-12 col-lg-2">
              <div class="d-flex justify-content-start justify-content-lg-end">
                <span class="btn btn-link text-decoration-none text-primary fw-semibold px-0">
                  View Account
                  <i class="bi bi-arrow-right-short ms-1"></i>
                </span>
              </div>
            </div>
          </div>
        </button>
      </div>

      <div class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2 p-3 border-top bg-light">
        <div class="text-muted small">
          Page {{ customer_page }} of {{ customer_total_pages }}
        </div>
        <div class="d-flex gap-2">
          <button
            class="btn btn-sm btn-primary rounded px-3"
            :disabled="customer_page === 1"
            @click="previous_customer_page"
          >
            Previous
          </button>
          <button
            class="btn btn-sm btn-primary rounded px-3"
            :disabled="customer_page === customer_total_pages"
            @click="next_customer_page"
          >
            Next
          </button>
        </div>
      </div>
    </section>

    <div v-else class="text-center py-5">
      <i class="bi bi-credit-card text-muted display-5"></i>
      <p class="text-muted mt-3 mb-0">No users on credit matched your current filters.</p>
    </div>
  </div>
</div>
